import React, { useState } from "react";
import "./Header.css";

const Header = () => {
  // fixed Header
  window.addEventListener("scroll", function () {
    const header = document.querySelector(".header");
    header.classList.toggle("active", window.scrollY > 100);
  });
  // Toogle Menu
  const [Mobile, setMobile] = useState(false);
  return (
    <>
      <header className="header" data-aos="fade-right" data-aos-duration="1000">
        <div className="container d_flex">
          <div className="logo">
            <p className="heading_text">Shivam</p>
          </div>

          <div className="navlink">
            <ul
              className={Mobile ? "nav-links-mobile" : "link f_flex uppercase"}
              onClick={() => setMobile(false)}
            >
              <li>
                <a href="#home">home</a>
              </li>
              <li>
                <a href="#features">features</a>
              </li>
              <li>
                <a href="#achievement">Achievement</a>
              </li>
              {/* <li>
                <a href="#portfolio">portfolio</a>
              </li> */}
              <li>
                <a href="#projects">Projects</a>
              </li>
              <li>
                <a href="#resume">Resume</a>
              </li>
              <li>
                <a href="#contact">contact</a>
              </li>
              <li>
                <a
                  href="https://drive.google.com/file/d/1H2h4AFMZlbfrME0_Uwd2E5KrtEI81ezO/view?usp=drive_link"
                  download
                >
                  <button className="home-btn">Hire me</button>
                </a>
              </li>
            </ul>

            <button className="toggle" onClick={() => setMobile(!Mobile)}>
              {Mobile ? (
                <i className="fas fa-times close home-btn"></i>
              ) : (
                <i className="fas fa-bars open"></i>
              )}
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
